import { DrawOption } from '@/modules/ta/widget/widget.constants';
import { DrawOptionItem } from '@/modules/ta/widget/models/drawoptions/DrawOptionItem';

/**
 *
 * @param {*} raw
 * @param {boolean} defaultValue
 * @returns {object}
 */
function normalizeDrawOption(raw, defaultValue) {
  if (raw === null || raw === undefined) return { value: defaultValue };
  return raw;
}

export class ReportStudioTemplateDrawOption {
  /**
   * @var {DrawOptionItem}
   */
  show_background;

  /**
   * @var {DrawOptionItem}
   */
  show_borders;

  /**
   * @var {DrawOptionItem}
   */
  show_title;

  /**
   * @var {DrawOptionItem}
   */
  show_data_source;

  /**
   * @param model
   */
  constructor(model = {}) {
    this.show_header = new DrawOptionItem(normalizeDrawOption(model.show_header, true));
    this.show_background = new DrawOptionItem(normalizeDrawOption(model.show_background, false));
    this.show_background.buildDrawOptionDefaultMetadata(DrawOption.SHOW_BACKGROUND);
    this.show_borders = new DrawOptionItem(normalizeDrawOption(model.show_borders, true));
    this.show_borders.buildDrawOptionDefaultMetadata(DrawOption.SHOW_BORDERS);
    this.show_title = new DrawOptionItem(normalizeDrawOption(model.show_title, true));
    this.show_title.buildDrawOptionDefaultMetadata(DrawOption.SHOW_TITLE);
    this.show_data_source = new DrawOptionItem(normalizeDrawOption(model.show_data_source, true));
    this.show_data_source.buildDrawOptionDefaultMetadata(DrawOption.SHOW_DATA_SOURCE);
  }
}
